import { Box, IconButton } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import styles from './styles';

function PropertySaveButton({
  isFavProperty,
  handleSaveProperty
}: {
  isFavProperty: boolean;
  handleSaveProperty: (typeInstruction: string, propRef: string) => void;
}) {
  return (
    <Box sx={styles.saveContainer}>
      <IconButton
        sx={styles.iconBtn}
        disableRipple
        aria-label="save-property"
        onClick={handleSaveProperty}
      >
        <FavoriteIcon className={isFavProperty ? 'saved' : 'unsaved'} />
      </IconButton>
    </Box>
  );
}

export { PropertySaveButton };
